import { useClientId } from "common/SessionContext";
import { useCustomQuery } from "utilities/hookutils";

export const useStatuses = (mainArea: server.dto.MainAreas) => {
  const clientId = useClientId();
  const statusQuery = useCustomQuery({
    queryFn: async () => window.CoreApi.Status.ListSmall({ clientId, mainArea }).then(r => r.data.data),
    queryKey: ["statuses", mainArea]
  });

  return statusQuery;
}

export const useHasMultipleStatuses = (mainArea: server.dto.MainAreas) => {
  const statusQuery = useStatuses(mainArea);
  if (statusQuery.isLoading) {
    return true;
  }
  return statusQuery.data.length > 1;
}